import React from 'react'
import PropTypes from 'prop-types'

import { withTracking } from '../ReactGAUtils/ReactGAUtils'

export const Anchor = withTracking(
  ({ sendEvent, onClick = () => {}, allowOpener = false, rel, ...props }) => {
    if (props['target'] === '_blank') {
      rel = allowOpener === true ? rel : 'noopener'
    }
    return (
      <a
        {...props}
        onClick={event => {
          sendEvent()
          onClick(event)
        }}
        rel={rel}
      />
    )
  }
)

Anchor.propTypes = {
  sendEvent: PropTypes.func,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  // override the safety mechanism that prevents access to window from other tabs
  allowOpener: PropTypes.bool,
  rel: PropTypes.string
}
